import React, { useEffect } from "react";
import { Elements, useStripe, useElements } from "@stripe/react-stripe-js";
import CheckoutForm, { Props as CheckoutFormProps } from "./CheckoutForm";
import { Stripe } from "@stripe/stripe-js";

interface WrapperProps extends CheckoutFormProps {
  stripePromise: Promise<Stripe | null>;
  onStripeReady: (stripe: Stripe | null, elements: any) => void;
}

const CheckoutFormWrapper: React.FC<WrapperProps> = ({
  stripePromise,
  onStripeReady,
  ...props
}) => {
  return (
    <Elements stripe={stripePromise}>
      <StripeProvider onStripeReady={onStripeReady}>
        <CheckoutForm {...props} />
      </StripeProvider>
    </Elements>
  );
};

const StripeProvider: React.FC<{
  onStripeReady: (stripe: Stripe | null, elements: any) => void;
  children: React.ReactNode;
}> = ({ onStripeReady, children }) => {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (stripe && elements) {
      onStripeReady(stripe, elements);
    }
  }, [stripe, elements]);

  return <>{children}</>;
};

export default CheckoutFormWrapper;
